import React from 'react'
import { getMessaging, getToken } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
// @ts-ignore
import { NotificationManager } from 'react-notifications'
import AddToHomeScreenButton from '../install-pwa'
import Button from '@mui/material/Button'
import { useAppDispatch, useAppSelector } from '../../redux'
import { enable, subscribe } from '../../redux/slices/settings'
import './index.scss'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyAMzR_JT_EkEEBTsYLOGCAB8TxIN9D2c0s',
    authDomain: 'autobet-pro.firebaseapp.com',
    projectId: 'autobet-pro',
    storageBucket: 'autobet-pro.appspot.com',
    messagingSenderId: '915627843886',
    appId: '1:915627843886:web:da3bea12d537671877dabf',
    measurementId: 'G-0SK3MP3L4P',
    vapidKey: 'BEJtP5Z3XNxRYun8FDZSul1dVUQ8nIY1v5-t1cv5hmH9gtyJvolFOcbtBMq9xWrTu1Ixv_vyxQ9IYNYghhkxuvg'
}

export async function requestForToken(success: any, fail: any) {
    let token = null
    try {
        if (window.Notification) {
            await Notification.requestPermission()
        }
        const app = await initializeApp(firebaseConfig)
        // await getAnalytics(app)

        token = getToken(getMessaging(app), { vapidKey: firebaseConfig.vapidKey })
            .then(async (currentToken: any) => {
                if (currentToken) {
                    return success(currentToken)
                }
                return fail('No registration token available. Request permission to generate one.')
            })
            .catch((err: any) => {
                return fail(err)
            })
    } catch (err) {
        fail(err)
    }

    return token
}

export async function requestTokenWithPermission(onSuccess: any) {
    return requestForToken(async (token: string) => onSuccess(token), (err: any) => {
            console.log('requestTokenWithPermission error', err)
        }
        // , (payload: any) => {
        //     console.log('Message received. ', payload.notification.title, payload.notification.body)
        //     // ...
        //     if (payload.notification.body === 'win') {
        //         NotificationManager.success(payload.notification.message, payload.notification.title)
        //     } else if (payload.notification.body === 'loss') {
        //         NotificationManager.error(payload.notification.message, payload.notification.title)
        //     } else {
        //         NotificationManager.warning(payload.notification.message, payload.notification.title)
        //     }
        // }
    )
}

const PWA = () => {
    const dispatch = useAppDispatch()
    const { notifications_config, notification_settings } = useAppSelector(state => state.settings)

    const handleSubscribe = (token: string) => dispatch(subscribe({ token }))
    React.useEffect(() => {
        if ('serviceWorker' in navigator) {
            const messageChannel = new MessageChannel()
            messageChannel.port1.onmessage = (event) => {
                console.log('[!!!!!!]Response from service worker:', event)
            }

            if (navigator.serviceWorker) {
                navigator.serviceWorker.addEventListener('message', (event) => {
                    const message = event.data
                    console.log('Received service worker message:', message)

                    if (message.isFirebaseMessaging === true) {
                        if (message.messageType === 'push-received') {
                            const { title, body } = message.notification
                            if (body === 'win') {
                                NotificationManager.success(body, title)
                            } else if (body === 'loss') {
                                NotificationManager.error(body, title)
                            } else {
                                NotificationManager.warning(body, title)
                            }
                            console.log('Received service worker message - handled')
                        }
                    }
                })
            }

            console.log('Registered for service worker messages')
        }

        dispatch(subscribe({
            token: localStorage.getItem('notifications_token')
        }))
        requestTokenWithPermission(handleSubscribe)


        // // Get the registration token for the current device
        // getToken(messaging, { vapidKey: 'BEJtP5Z3XNxRYun8FDZSul1dVUQ8nIY1v5-t1cv5hmH9gtyJvolFOcbtBMq9xWrTu1Ixv_vyxQ9IYNYghhkxuvg' })
        //     .then((currentToken: string) => {
        //         if (currentToken) {
        //             // Send the registration token to your server
        //             // for managing push notifications
        //         }
        //     })

    }, [])

    const enablePermissions = async () => {
        dispatch(enable())
        await requestTokenWithPermission(handleSubscribe)
    }

    const isRunningAsPWA = window.matchMedia('(display-mode: standalone)').matches
    const accepted = (!!window.Notification && notifications_config.enabled)
    const notifications_available = !accepted && !!window.Notification && 'permission' in window.Notification

    let message = 'For notifications you must Allow notifications for this page.'
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
    if (isIOS) {
        message = 'For notifications: Add to Home Screen then Allow notifications'
    }
    const isAndroid = /Android/.test(navigator.userAgent)
    if (isAndroid) {
        message = 'For notifications, Add to Home Screen then Allow notifications'
    }

    return <div style={{ margin: '5px' }}>
        {!isRunningAsPWA && <AddToHomeScreenButton />}
        {notifications_available && <Button className='pro-button' variant='outlined' onClick={() => enablePermissions()}>Enable notifications</Button>}
        {!notifications_available && !accepted && <Button className='pro-button' variant='outlined'>{message}</Button>}
    </div>
}

export default PWA
